module.exports = __webpack_public_path__ + "static/media/italics.10da74fb.svg";